import React from 'react';
import PropTypes from 'prop-types';
import HorizontalRule from '~/shared/components/HorizontalRule';
import cl from 'classnames';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const RuledHeader = props => {
  return (
    <div className="ndx-RuledHeader">
      {props.align !== 'left' && <HorizontalRule />}
      <p className={cl('ndx-RuledHeader-text', `is-${props.align}`)}>
        {props.children || props.headerText}
      </p>
      {props.align !== 'right' && <HorizontalRule />}
    </div>
  );
};

const propTypes = {
  align: PropTypes.oneOf(['left', 'right', 'center']),
  children: PropTypes.node,
  headerText: PropTypes.string
};

RuledHeader.propTypes = propTypes;

RuledHeader.defaultProps = {
  headerText: '',
  align: 'center'
};

RuledHeader.displayName = 'RuledHeader';

export default RuledHeader;
